<template>
  <div>
    <div class="bg">
      <div class="title mt10">
        基本信息
      </div>
      <div class="mt20 flex">
        <div class="mr10" style="width: 66px">
          <el-image
              style="width: 66px; height: 66px"
              :src="titleImg"
          >
          </el-image>
        </div>
        <div class="flex-1 flex flex-column flex-around">
          <div>奶粉的新客群</div>
          <div class="title-qz-ms">群主：橙橙橙 13121869874<span class="ml20">共312位群成员</span></div>
        </div>
      </div>
      <div class="flex mt40 mb20">
        <div
            style="line-height: 30px;"
            class="divder pointer  flex-1 flex flex-center"
            v-for="(v, i) in marketingData"
            :key="i"
        >
          <div>
            <div class="flex item-center" style="white-space:nowrap;">
              <el-image
                  style="width: 17px;height:17px;margin-right:5px"
                  :src="v.img"
              ></el-image>
              <!--<span  class="hmicon primary" style="margin-right: 5px" :class="v.icon"></span>-->
              <span>{{ v.title }}</span>
            </div>
            <div class="flex flex-center">
              <span class="fw">{{ v.value }}</span>
              <span class="unit-size">{{
                  v.unit
                }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg mt10">
      <div class="title mt10">
        商品销售统计
      </div>
      <el-table
          :data="goodList"
          border
          stripe
          class="mt20"
          size="small"
          style="width: 100%">
        <el-table-column
            header-align="center"
            align="center"
            prop="name"
            label="商品"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="user"
            label="点击数">
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="num"
            label="加购数">
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="joingNum"
            label="下单数">
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="goodTotal"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="goodCurrentPage"
        ></el-pagination>
      </div>
    </div>
    <hm-content class="mt10">
      <div class="title mt10">
        客户销售统计
      </div>
      <el-table
          :data="customerList"
          border
          stripe
          class="mt20"
          size="small"
          style="width: 100%">
        <el-table-column
            header-align="center"
            align="center"
            prop="name"
            label="客户"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="user"
            label="点击商品数">
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="num"
            label="加购商品数">
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="num"
            label="成交金额">
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="joingNum"
            label="下单数">
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="customerTotal"
            @current-change="customerPaging"
            @size-change="customerHandleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="customerCurrentPage"
        ></el-pagination>
      </div>
    </hm-content>
  </div>

</template>

<script>
export default {
  data() {
    return {
      goodList: [],
      goodTotal: 0,
      goodCurrentPage: 1,
      goodPageSize: 10,
      customerList: [],
      customerTotal: 0,
      customerCurrentPage: 1,
      customerPageSize: 10,
      searchCondition: {},
      titleImg: "https://imgcdn.hemiao100.com/ThemePictures/%E8%AE%A1%E5%88%92%E5%9F%BA%E6%9C%AC%E7%BB%86%E8%85%BB%402x.png",
      marketingData: [
        {
          title: "总人数",
          value: "0",
          unit: "位",
          img: "https://imgcdn.hemiao100.com/ThemePictures/renshu.png"
        },
        {
          title: "总客户数",
          value: "0",
          unit: "位",
          img: "https://imgcdn.hemiao100.com/ThemePictures/hushu.png"
        },
        {
          title: "今日新增",
          value: "0",
          unit: "位",
          img: "https://imgcdn.hemiao100.com/ThemePictures/xinzeng.png"
        },
        {
          title: "今日退群",
          value: "0",
          unit: "位",
          img: "https://imgcdn.hemiao100.com/ThemePictures/tuiqun.png"
        }
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    async queryGoodList() {
      const params = {
        pageSize: this.goodPageSize,
        pageNo: this.goodCurrentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("", params);
      if (code === "0") {
        const { total, records } = result;
        this.goodList = records;
        this.goodTotal = total;
      }
    },
    async queryCustomerList() {
      const params = {
        pageSize: this.customerPageSize,
        pageNo: this.customerCurrentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("", params);
      if (code === "0") {
        const { total, records } = result;
        this.customerList = records;
        this.customerTotal = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryGoodList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryGoodList();
    },
    customerPaging(page) {
      this.customerCurrentPage = page;
      this.queryCustomerList();
    },
    customerHandleSizeChange(size) {
      this.customerCurrentPage = 1;
      this.customerPageSize = size;
      this.queryCustomerList();
    }
  },
};
</script>

<style scoped lang="scss">
.bg {
  background-color: #fff;
  padding: 20px;
}
.title {
  color: rgba(34, 34, 34, 1);
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 16px;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 3px;
    height: 14px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.title-qz-ms {
  font-size: 14px;
  color: #222222;
}
.divder {
  border-left: 1px solid #eee;
  .fw {
    font-size: 28px;
  }
  .unit-size {
    font-size: 14px;
  }
}
.divder:nth-child(1) {
  border-left: none;
}
</style>
